<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  text-align: center;
}

.loading-spinner p {
  margin: 0;
  font-size: 1rem;
}

/* Customização do SweetAlert2 para o tema Valora */
.swal2-popup {
  border-radius: 0.75rem !important;
  padding: 1.5rem !important;
  z-index: 99999 !important;
}

.swal2-container {
  z-index: 99999 !important;
}

.swal2-backdrop-show {
  z-index: 99998 !important;
}

.swal2-title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #344767 !important;
}

.swal2-content {
  font-size: 1rem !important;
  color: #67748e !important;
}

.swal2-confirm {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%) !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 0.75rem 1.5rem !important;
  border-radius: 0.5rem !important;
  transition: all 0.3s ease !important;
}

.swal2-confirm:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3) !important;
}

.swal2-confirm:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3) !important;
}

.swal2-success .swal2-success-ring {
  border-color: #20c997 !important;
}

.swal2-success [class^=swal2-success-line] {
  background-color: #20c997 !important;
}

.swal2-icon.swal2-success {
  border-color: #20c997 !important;
  color: #20c997 !important;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: #20c997 !important;
}
</style>
